<template>
  <Modal v-model="abnormalQuantityModal" :title="$t('key1004954')" width="900" :transfer="false"
    :mask-closable="false" @on-visible-change="abnormalQuantityModalChange">
    <Alert type="warning" show-icon style="padding: 8px 35px;">
      {{ $t('key1004955') }}
    </Alert>
    <div class="table_box">
      <Table
        highlight-row
        border
        max-height="500"
        :span-method="handleSpan"
        :loading="tableLoading"
        :columns="abnormalQuantityColumns"
        :data="abnormalQuantityData">
      </Table>
    </div>
    <template #footer>
      <div style="text-align: right;">
        <Button @click="abnormalQuantityModal = false">{{ $t('key1004956') }}</Button>
        <Button type="error" @click="markCompletionBtn">{{ $t('key1004925') }}</Button>
      </div>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';

export default {
  name: "abnormalQuantityModal",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      abnormalQuantityModal: false,
      abnormalQuantityData: [],
      abnormalQuantityColumns: [
        {
          type: 'index',
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000343'),
          width: 70,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001248'),
          key: 'packageCode',
          minWidth: 120,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000239'),
          key: 'skuInfo',
          align: 'center',
          minWidth: 400,
          render(h, params) {
            let imgPath = params.row.pictureUrl;
            let spec = params.row.productGoodsSpecifications;
            return h('div', {class: 'flex mt5 mb5'}, [
              v.tableImg(h, params, null, imgPath),
              h('div', {class: 'ml5'}, [
                h('div', {class: 'flex align-items-start mb5'},
                  [
                    h('p', {
                      style: {
                        width: '70px',
                        textAlign: 'right'
                      }
                    }, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000100')),
                    h('p', {
                      style: {
                        flex: 1,
                        textAlign: 'left'
                      }
                    }, params.row.title),
                  ]),
                h('div', {class: 'flex align-items-start mb5'}, [
                  h('p', {
                    style: {
                      width: '70px',
                      textAlign: 'right'
                    }
                  }, 'SKU：'),
                  h('p', {
                    style: {
                      flex: 1,
                      textAlign: 'left'
                    }
                  }, params.row.ymsSku),
                ]),
                h('div', {class: 'flex align-items-start mb5'}, [
                  h('p', {
                    style: {
                      width: '70px',
                      textAlign: 'right'
                    }
                  }, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000240')),
                  h('p', {
                    style: {
                      flex: 1,
                      textAlign: 'left'
                    },
                    class: 'color-green'
                  }, spec),
                ]),
              ])
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004952'),
          key: 'quantity',
          minWidth: 100,
          align: 'center',
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004953'),
          key: 'scanQuantity',
          minWidth: 100,
          align: 'center',
        },
      ]
    };
  },
  methods: {
    // 初始化数据
    initAbnormalQuantityData(data) {
      let v = this;
      let newList = [];
      if (data && data.length > 0) {
        data.map((ele, index) => {
          let length = ele.goodsLength;
          ele['length'] = length;
          ele['currentTalg'] = (length > 1 && index === 0);
          newList.push(ele);
        });
        if (newList.length > 0) {
          newList.map((item, index) => {
            item['tableLength'] = newList.length;
            if (item.currentTalg) {
              item['currentIndex'] = index;
            }
          });
          v.abnormalQuantityData = newList;
        }
        v.abnormalQuantityModal = true;
      }
    },
    // 标记完结
    markCompletionBtn() {
      let v = this;
      v.$emit('completeBtn', false);
    },
    // 监听弹窗
    abnormalQuantityModalChange(value) {
      if (!value) {
        this.abnormalQuantityData = [];
      }
    },
    // 合并单元格
    handleSpan({row, column, rowIndex, columnIndex}) {
      let columnList = [0, 1];
      if (columnList.includes(columnIndex)) {
        if (row.length > 1) {
          if (rowIndex === row.currentIndex) {
            return [row.length, 1];
          } else {
            for (let i = 0; i <= row.tableLength; i++) {
              if (rowIndex === i) {
                return [0, 0];
              }
            }
          }
        }
      }
    },
  }
};
</script>

<style scoped>

</style>